/**
 * MinistrareIA - Lead Service
 * API service for lead management
 */
import api from './api';

const BASE = '/api/leads';

class LeadService {
  /** List all leads (optional status filter) */
  async list(status = null) {
    const params = {};
    if (status) params.status = status;
    const response = await api.get(BASE, { params });
    return response.data;
  }

  /** Get lead by ID */
  async getById(id) {
    const response = await api.get(`${BASE}/${id}`);
    return response.data;
  }

  /** Create new lead */
  async create(data) {
    const response = await api.post(BASE, data);
    return response.data;
  }

  /** Update lead */
  async update(id, data) {
    const response = await api.put(`${BASE}/${id}`, data);
    return response.data;
  }

  /** Delete lead */
  async delete(id) {
    const response = await api.delete(`${BASE}/${id}`);
    return response.data;
  }

  /** Get dashboard stats */
  async getStats() {
    const response = await api.get(`${BASE}/stats`);
    return response.data;
  }

  /** Reset follow-up progress for a lead */
  async resetFollowup(id) {
    const response = await api.post(`${BASE}/${id}/reset-followup`);
    return response.data;
  }

  /** Send a WhatsApp message to a lead */
  async sendMessage(id, message) {
    const response = await api.post(`${BASE}/${id}/send-message`, { message });
    return response.data;
  }

  /** Get follow-up progress for a lead */
  async getFollowupProgress(id) {
    const response = await api.get(`${BASE}/${id}/followup-progress`);
    return response.data;
  }

  /** Toggle follow-up active/inactive for a lead */
  async toggleFollowup(id, active) {
    const response = await api.post(`${BASE}/${id}/toggle-followup`, { active });
    return response.data;
  }

  /** Get follow-up day-by-day status for a lead */
  async getFollowupDays(id) {
    const response = await api.get(`${BASE}/${id}/followup-days`);
    return response.data;
  }

  /** Painel de manutenção: todos os leads com situação no follow-up, alertas e contagens (1 chamada) */
  async painel() {
    const response = await api.get(`${BASE}/painel`);
    return response.data;
  }

  /** Dispara uma ação de manutenção para vários leads (job em background) */
  async acaoLote(acao, leadIds, dia = null) {
    const body = { acao, lead_ids: leadIds };
    if (dia) body.dia = dia;
    const response = await api.post(`${BASE}/acoes`, body);
    return response.data;
  }

  /** Progresso/resultado de um job de ação em lote */
  async jobStatus(jobId) {
    const response = await api.get(`${BASE}/acoes/${jobId}`);
    return response.data;
  }

  /** Update which days a lead has received in a follow-up */
  async updateFollowupDays(id, sentDays) {
    const response = await api.post(`${BASE}/${id}/update-followup-days`, { sent_days: sentDays });
    return response.data;
  }
}

const leadService = new LeadService();
export default leadService;
